export function createRecoverFormButtonProps({ isLoading, isSubmitDisabled, onCancel, onMobileNext, }) {
    const next = {
        type: "submit",
        variant: "filled",
        size: "large",
        loading: isLoading,
        disabled: isSubmitDisabled,
    };
    const cancel = {
        type: "button",
        variant: "outlined",
        size: "large",
        onClick: onCancel,
    };
    const nextMobile = onMobileNext
        ? {
            type: "button",
            variant: "filled",
            size: "large",
            loading: isLoading,
            disabled: isSubmitDisabled,
            onClick: onMobileNext,
        }
        : next;
    return { next, cancel, nextMobile };
}
//# sourceMappingURL=recover-form-button-props.js.map